var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.86 10.9284L2.5768 12.1658H2.57665C2.39321 12.1864 2.22024 12.2617 2.08025 12.382C1.94025 12.5022 1.83962 12.6617 1.79166 12.84L0.0316564 19.4276C-0.0303756 19.6574 -0.000531149 19.9022 0.114936 20.1102C0.230404 20.3183 0.422437 20.4732 0.650257 20.5421C0.877913 20.611 1.1237 20.5885 1.3351 20.4793L19.6371 11.1057C19.8382 11.0029 19.9943 10.8293 20.0751 10.6183C20.156 10.4074 20.156 10.1739 20.0751 9.96299C19.9943 9.75205 19.8382 9.57845 19.6371 9.47563L1.3351 0.102026C1.12369 -0.0071935 0.877897 -0.0296935 0.650257 0.0392145C0.422445 0.108123 0.230416 0.262967 0.114936 0.471095C-0.000531549 0.679063 -0.0303756 0.923895 0.0316564 1.15373L1.79166 7.74133C1.83962 7.91961 1.94025 8.07915 2.08025 8.19929C2.22025 8.31961 2.39322 8.39492 2.57665 8.41554L13.8598 9.6529H13.86C14.0755 9.67056 14.2675 9.79571 14.3705 9.98587C14.4735 10.176 14.4735 10.4054 14.3705 10.5956C14.2675 10.7857 14.0755 10.9109 13.86 10.9285V10.9284Z",
    fill: "#3786F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.d8797eb9d44b879e3cc65c31fc5b59ba.svg";
export { ForwardRef as ReactComponent };